import { ViewModel,View, ObservableArray, ViewModelMessage } from "binder"
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { ServerConnection } from "src/server/serverConnection";
import  { AccessManagementView } from "./accessManagement-view"

export class AccessManagementViewModel extends WindowViewModel{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.users = ObservableArray.create<UserViewModel>();
        this.forms = ObservableArray.create<FormViewModel>();
        this.refresh();
    }

    GetDefaultView(): View <ViewModel> {
        return new AccessManagementView();
    }
    public getTypeId(): string {
        return "VM-623AEFD3-3B4E-412C-879B-1A2F8CED08B1"
    }

    public getTitle(): string {
        return "تنظیم دسترسی";
    }
    
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    
    public set users(v: ObservableArray<UserViewModel>) { this._users = v; } public get users(): ObservableArray<UserViewModel> { return this._users;} private _users: ObservableArray<UserViewModel>;
    public set selectedUser(v: UserViewModel) { this._selectedUser = v; } public get selectedUser(): UserViewModel { return this._selectedUser;} private _selectedUser: UserViewModel;
    
    public set forms(v: ObservableArray<FormViewModel>) { this._forms = v; } public get forms(): ObservableArray<FormViewModel> { return this._forms;} private _forms: ObservableArray<FormViewModel>;
    
    async refresh() {
        try {
            this.isLoading = true;
            await Promise.all([this.getAllUsers(),this.getAllForms()]);
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
        
        this.isLoading = true;
        this.getAllUsers();
        this.getAllForms();
        this.isLoading = false;
    }

    async getAllUsers() {
        try{
            let result = await ServerConnection.callServer('Complex/SecurityRawDataServices/GetAllUsers', {});
            this.users.update(...result.Users.map(x => {
                let r = new UserViewModel(this);
                r.userId = x.Id;
                r.username = x.Username;
                r.setPersonnelFullName(x.PersonnelName,x.PersonnelLastName);
                return r;
            }));
        }
        catch (ex) {
            console.log(ex);
        }
    }

    async getAllForms() {
        try{
            let result = await ServerConnection.callServer('Complex/SecurityRawDataServices/GetAllForms', {});
            this.forms.update(...result.Forms.map(x => {
                let r = new FormViewModel(this);
                r.formId = x.Id;
                r.formName = x.Name;
                r.isSelected = false;
                r.hasAccess = false;
                return r;
            }));
        }
        catch (ex) {
            console.log(ex);
        }
    }

    async getAccessibleForms() {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('Complex/SecurityRawDataServices/GetAccessibleForms', {UserId:this.selectedUser.userId});
            let accessibleForms = result.Forms.map(x=>x.Id);
            this.forms.forEach(element => {
                if (accessibleForms.includes(element.formId)){
                    element.hasAccess = true;
                }else{
                    element.hasAccess = false
                }
            });
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

    selectAccessRight(form: FormViewModel) {
        this.forms.forEach(x=>x.isSelected = false);
        form.isSelected = true;
    }

    selectUser(user: UserViewModel) {
        this.users.forEach(x=>x.isSelected = false);
        user.isSelected = true;
        this.selectedUser = user;
        this.getAccessibleForms();
    }

    async save(){
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('Complex/SecurityRawDataServices/SetUserAccesses', {
                UserId: this.selectedUser.userId,
                AllowedForms: this.forms.filter(x => x.hasAccess == true).map(x => x.formId)
            });
            let a = 0;
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
}

export class FormViewModel extends ViewModel{
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent:AccessManagementViewModel) {
        super(parent);
        this.typedParent = parent;
    }

    private typedParent: AccessManagementViewModel;
    public set formId(v: string) { this._formId = v; } public get formId(): string { return this._formId;} private _formId: string;
    public set formName(v: string) { this._formName = v; } public get formName(): string { return this._formName;} private _formName: string;
    public set isSelected(v: boolean) { this._isSelected = v; } public get isSelected(): boolean { return this._isSelected;} private _isSelected: boolean;
    public set hasAccess(v: boolean) { this._hasAccess = v; } public get hasAccess(): boolean { return this._hasAccess;} private _hasAccess: boolean;

    select(){
        this.typedParent.selectAccessRight(this);
    }

}

export class UserViewModel extends ViewModel{
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent:AccessManagementViewModel) {
        super(parent);
        this.typedParent = parent;
    }

    private typedParent : AccessManagementViewModel;
    public set userId(v: string) { this._userId = v; } public get userId(): string { return this._userId;} private _userId: string;
    public set username(v: string) { this._username = v; } public get username(): string { return this._username;} private _username: string;
    public set personnelName(v: string) { this._personnelName = v; } public get personnelName(): string { return this._personnelName;} private _personnelName: string;
    public set personnelLastName(v: string) { this._personnelLastName = v; } public get personnelLastName(): string { return this._personnelLastName;} private _personnelLastName: string;
    public set personnelFullName(v: string) { this._personnelFullName = v; } public get personnelFullName(): string { return this._personnelFullName;} private _personnelFullName: string;
    
    public set isSelected(v: boolean) { this._isSelected = v; } public get isSelected(): boolean { return this._isSelected;} private _isSelected: boolean;
    
    select(){
        this.typedParent.selectUser(this);
    }
    setPersonnelFullName(name:string,lastName:string){
        this.personnelName = name;
        this.personnelLastName = lastName;
        this.personnelFullName = [name,lastName].filter(x=>stringIsNullOrEmpty(x)==false).map(x=>x.trim()).join(' ');
    }
}